import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { WorkflowGraphVertexInteractionPoint } from './workflow-graph-vertex-interaction-point';
import {
  WorkflowGraphDispatcherAction,
  WorkflowGraphDispatcherActionType,
  WorkflowGraphDispatcherService
} from '../../workflow-graph-dispatcher.service';
import { WorkflowGraphService } from '../../workflow-graph.service';

@Component({
  selector: 'g[wf-graph-vertex-outlet-point]',
  template: `

    <svg:text class="io-type" [ngClass]="{'activated-io-type': activate}" [attr.x]="textX" [attr.y]="textY"
              font-size="14"
              [attr.text-anchor]="anchor">
      <svg:tspan font-weight="bold">{{ name }}</svg:tspan>
      <svg:tspan>:</svg:tspan>
      <svg:tspan>{{ typeText }}</svg:tspan>
    </svg:text>

    <svg:circle *ngIf="initialized" xmlns:svg="http://www.w3.org/1999/html" [attr.cx]="specification.at.x"
                [attr.cy]="specification.at.y" fill="#000" stroke="#00F" stroke-width="1" [ngClass]="{'anchor-point': editable}"
                (mousedown)="onMouseDown($event)" [class.highlighted-point]="highlight"
                [attr.r]="radius"/>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkflowGraphVertexOutletPointComponent extends WorkflowGraphVertexInteractionPoint implements OnInit, OnDestroy {

  activate = false;
  highlight = false;

  constructor(dispatcherService: WorkflowGraphDispatcherService, graphService: WorkflowGraphService, protected cdr: ChangeDetectorRef) {
    super(dispatcherService, graphService);
  }

  onMouseDown(event: MouseEvent) {
    if (!this.editable) {
      // Nothing to do here.
      return;
    }

    if (event.which !== 1) {
      // If its not a left click, ignore it.
      return;
    }

    this.dispatcherService.dispatchAction(WorkflowGraphDispatcherActionType.ConnectionDrawInitiated, this, event);
    this.activate = true;
    this.highlight = true;
    this.cdr.markForCheck();
  }

  onDispatcherEvent(action: WorkflowGraphDispatcherAction) {
    switch (action.type) {
      case WorkflowGraphDispatcherActionType.ConnectionDrawTerminated:
        this.activate = false;
        this.highlight = false;
        this.cdr.markForCheck();
        break;
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  get direction(): string {
    return 'out';
  }
}



// WEBPACK FOOTER //
// ./src/library/graph/vertex/interaction-point/workflow-graph-vertex-outlet-point.component.ts